<template>
    <div class="container mx-auto my-10 p-8 lg:p-0">
        <slot />
    </div>
</template>